<template>
  <div>
    <v-navigation-drawer
      v-model="showLog"
      width="100%"
      :right="true"
      absolute
      touchless
      temporary
    >
      <MvWdAisaChat />
    </v-navigation-drawer>
  </div>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)

//例如: import <组件名称> from  <组建路径>
import MvWdAisaChat from "../chat/cd-chat.vue";

export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {
    MvWdAisaChat,
  },
  props: {},
  data() {
    //这里存放数据
    return {
      showLog:true
    };
  },
  //计算机属性 类似与data概念
  computed: {},
  //监控data中数据变化
  watch: {},
  methods: {},
  //生命周期-创建完成(可以访问当前this实例)
  created() {},
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {},
  destroyed() {}, //生命周期-销毁完成
  activated() {
    this.showLog = true
  }, //如果页面有keep-alive,这函数会触发
};
</script>

<style lang="scss"></style>
